import React from "react";

const ErrorTest = () => {
  throw new Error("Testing Sentry integration!");

  // eslint-disable-next-line
  return <div></div>;
};

export default ErrorTest;
